











































import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { isDesktop } from '@/helpers/isDesktop';
import { Action, Getter } from 'vuex-class';
import type { DynamicField } from '@/models/dynamicField';
import type { CompanySetting } from '@/models/companySetting';

@Component({
    name: 'FormDynamicFieldPicker',
})
export default class FormDynamicFieldPicker extends Vue {
    @Model('input', {
        required: true,
    })
    private dynamicField: DynamicField;

    @Prop({
        required: false,
        default: () => [],
    })
    private availableDynamicFields: DynamicField[];

    @Prop({
        required: false,
        default: () => false,
    })
    private disabled: boolean;

    private defaultDynamicFields: DynamicField[] = [];

    private isDesktop = isDesktop();

    @Getter('company/dynamicFields') private dynamicFields: DynamicField[];
    @Action('company/fetchAllDynamicFields') private fetchAllDynamicFields: any;
    @Getter('account/companySetting') private companySetting: CompanySetting;

    mounted() {
        if (this.availableDynamicFields.length === 0) {
            this.loadOptions();
        }
    }

    loadOptions() {
        this.defaultDynamicFields = this.dynamicFields;
    }

    get selected() {
        return this.dynamicField;
    }

    get available() {
        return this.availableDynamicFields.length > 0 ? this.availableDynamicFields : this.defaultDynamicFields;
    }
}
